import { COLOR_BASE_GREY_5 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { transitionDuration, transitionTiming, zIndexCatalogue } from '~/styles/tokens';

export const SliderPanelStyle = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
`;

export const SliderPanelCanvasStyle = styled.div`
	width: 100%;
	height: 100%;
	position: relative;

	transition-timing-function: ${transitionTiming};
	transition-duration: ${transitionDuration}ms;
	background-color: transparent;
	transition-property: background-color, top, left, height;
	overflow: hidden;
`;

export const SliderPanelCanvasInnerStyle = styled.div<{ sliderSpaceBetween: number }>`
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	min-width: min-content;
	max-width: min-content;
	left: 0;
	top: 0;
	height: auto;
	padding-left: ${(props) => props.sliderSpaceBetween / 2}px;
	transition-timing-function: ${transitionTiming};
	transition-duration: ${transitionDuration}ms;
	transition-property: left, top, height;

	&.expanded {
		position: fixed;
		flex-direction: column;
		z-index: ${zIndexCatalogue};
		overflow: hidden;
		padding-right: ${(props) => props.sliderSpaceBetween / 2}px;
		max-width: none;
		background-color: ${COLOR_BASE_GREY_5};
	}
`;
